import { useState, useCallback } from 'react';

const STORAGE_KEY = 'fastlane_tablet_building_id';

export function usePersistedBuilding() {
	const [buildingId, setBuildingIdState] = useState<string | null>(() => {
		return localStorage.getItem(STORAGE_KEY);
	});

	const setBuildingId = useCallback((id: string) => {
		localStorage.setItem(STORAGE_KEY, id);
		setBuildingIdState(id);
	}, []);

	const clearBuildingId = useCallback(() => {
		localStorage.removeItem(STORAGE_KEY);
		setBuildingIdState(null);
	}, []);

	return { buildingId, setBuildingId, clearBuildingId };
}
